import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import { SelectWrapper, Select as Select$2, FakeSelect, Label, SelectedItem } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CHEVRON_DOWN } from '../../icons/ICON_UI_CHEVRON_DOWN.js';

var _excluded = ["id", "label", "value", "onChange", "items", "disabled", "invalid", "defaultValue", "autoComplete", "roundCorners"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SelectItem = function SelectItem(potentialKVP) {
  if (typeof potentialKVP === 'undefined' || potentialKVP.constructor === Array) {
    return false;
  }

  // TODO: null is a problem!
  return {
    name: "".concat(potentialKVP.name !== undefined ? potentialKVP.name : potentialKVP),
    value: "".concat(potentialKVP.value !== undefined ? potentialKVP.value : potentialKVP)
  };
};
var DEFAULT_FALLBACK = {
  name: '',
  value: '-1'
};
var Select = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$id = props.id,
    id = _props$id === void 0 ? null : _props$id,
    _props$label = props.label,
    label = _props$label === void 0 ? null : _props$label,
    _props$value = props.value,
    value = _props$value === void 0 ? null : _props$value,
    _onChange = props.onChange,
    _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? null : _props$defaultValue,
    _props$autoComplete = props.autoComplete,
    autoComplete = _props$autoComplete === void 0 ? null : _props$autoComplete,
    _props$roundCorners = props.roundCorners,
    roundCorners = _props$roundCorners === void 0 ? false : _props$roundCorners,
    rest = _objectWithoutProperties(props, _excluded);
  if (typeof _onChange !== 'function' || !items || !items.length || items.constructor !== Array) {
    return false;
  }
  var normalizedItems = items.map(function (item) {
    return _objectSpread(_objectSpread({}, SelectItem(item)), {}, {
      disabled: item.disabled
    });
  });
  var selectedItem = normalizedItems.find(function (v) {
    return v.value === value;
  });
  if (!selectedItem) {
    // NB: If the fallback to default failed (e.g. it was empty),
    //     we need some type of default outline
    selectedItem = SelectItem(defaultValue) || DEFAULT_FALLBACK;
    if (!normalizedItems.find(function (v) {
      return v.value === selectedItem.value;
    })) {
      normalizedItems.unshift(selectedItem);
    }
  }
  var options = normalizedItems.map(function (item) {
    return item.value && item.name && /*#__PURE__*/jsx("option", {
      value: item.value,
      disabled: item.disabled,
      children: item.name
    }, item.value);
  }).filter(function (v) {
    return v;
  });
  if (!options.length) {
    return false;
  }
  var potentialSelectProps = {};
  if (autoComplete) {
    potentialSelectProps.autoComplete = autoComplete;
  }
  var hasNoLabel = !label || label.length < 1;
  return /*#__PURE__*/jsxs(SelectWrapper, _objectSpread(_objectSpread({
    $disabled: disabled,
    $hasNoLabel: hasNoLabel
  }, rest), {}, {
    children: [/*#__PURE__*/jsx(Select$2, _objectSpread(_objectSpread({
      value: selectedItem.value,
      onChange: function onChange(event) {
        return _onChange(event);
      },
      name: id,
      id: id,
      "aria-disabled": disabled,
      $disabled: disabled,
      ref: ref
    }, potentialSelectProps), {}, {
      children: options
    })), /*#__PURE__*/jsxs(FakeSelect, {
      $roundCorners: roundCorners,
      $invalid: invalid,
      $disabled: disabled,
      children: [label && /*#__PURE__*/jsx(Label, {
        htmlFor: id,
        $disabled: disabled,
        children: label
      }), /*#__PURE__*/jsxs(SelectedItem, {
        $disabled: disabled,
        children: [selectedItem.name, /*#__PURE__*/jsx(Icon, {
          path: ICON_UI_CHEVRON_DOWN,
          className: "sg-select-icon"
        })]
      })]
    })]
  }));
});
Select.displayName = 'Select';
var Select$1 = Select;

export { Select$1 as default };
//# sourceMappingURL=Select.js.map
